import { clearAllBodyScrollLocks, enableBodyScroll } from 'body-scroll-lock';
import { App, nextTick, reactive } from 'vue';

declare module '@vue/runtime-core' {
// eslint-disable-next-line @typescript-eslint/naming-convention
  interface ComponentCustomProperties {
    $nav: INavPlugin;
  }
}

export interface INavPlugin {
  data: {
    navActive: boolean;
    navSection: string;
    oldNavSection: string;
    scrollableElm: HTMLElement | null;
  };
  readonly navOpened: boolean;
  show(section?: string): void;
  hide(): void;
  manageScroll(scrollableElm: HTMLElement): void;
}

export default {
  install: (app: App, options: Record<string, any>) => {
    const navData = reactive({
      navActive: false,
      navSection: '',
      oldNavSection: '',
      scrollableElm: null as HTMLElement | null,
    });

    const nav: INavPlugin = {
      data: navData,

      get navOpened() {
        return !options?.adaptive.isDesktop && navData.navActive;
      },

      show(section = '') {
        clearAllBodyScrollLocks();
        navData.oldNavSection = navData.navSection;
        navData.navSection = section;
        navData.navActive = true;
      },

      hide() {
        navData.navActive = false;
        navData.navSection = '';
        navData.oldNavSection = '';
        clearAllBodyScrollLocks();
      },

      manageScroll(scrollableElm) {
        if (navData.scrollableElm) clearAllBodyScrollLocks();

        nextTick(() => {
          navData.scrollableElm = scrollableElm;
          if (navData.scrollableElm) enableBodyScroll(navData.scrollableElm);
        });
      },
    };

    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$nav = nav;
  },
};
